const features = [
  {
    number: '01',
    title: 'Pour les enfants',
    description:
      "Le moment tant attendu : qui trouvera la fève ? Une couronne pour les rois et reines du jour, et un espace sécurisé et convivial pour retrouver les copains de l'école.",
    icon: (
      <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
  },
  {
    number: '02',
    title: 'Gastronomie & Tradition',
    description:
      'Dégustez la véritable Frangipane préparée par les chefs pâtissiers du Pullman. Croustillante, dorée, et servie tiède. Un délice purement français.',
    icon: (
      <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M21 15.546c-.523 0-1.046.151-1.5.454a2.704 2.704 0 01-3 0 2.704 2.704 0 00-3 0 2.704 2.704 0 01-3 0 2.704 2.704 0 00-3 0 2.704 2.704 0 01-3 0 2.701 2.701 0 00-1.5-.454M9 6v2m3-2v2m3-2v2M9 3h.01M12 3h.01M15 3h.01M21 21v-7a2 2 0 00-2-2H5a2 2 0 00-2 2v7h18zm-3-9v-2a2 2 0 00-2-2H8a2 2 0 00-2 2v2h12z" />
      </svg>
    ),
  },
  {
    number: '03',
    title: 'Réseautage Parents',
    description:
      "L'occasion idéale pour échanger avec d'autres parents et membres de l'UFE dans une ambiance détendue pendant que les enfants s'amusent.",
    icon: (
      <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
      </svg>
    ),
  },
];

export default function EventSection() {
  return (
    <section id="event" className="py-24 lg:py-32 bg-cream paper-texture">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section header */}
        <div className="max-w-3xl mx-auto text-center mb-20">
          <span className="inline-block font-body text-sm text-burgundy uppercase tracking-[0.2em] mb-4">
            L'Expérience
          </span>
          <h2 className="font-serif font-semibold text-4xl md:text-5xl text-navy-900 mb-6 leading-tight">
            Plus qu'une galette,
            <span className="block text-gradient-gold">des souvenirs</span>
          </h2>
          <div className="flex items-center justify-center gap-4 mb-8">
            <div className="h-px w-12 bg-gradient-to-r from-transparent to-gold/50" />
            <div className="w-1.5 h-1.5 rotate-45 bg-gold" />
            <div className="h-px w-12 bg-gradient-to-l from-transparent to-gold/50" />
          </div>
          <p className="font-body text-lg text-navy-600 leading-relaxed">
            Une après-midi pensée pour toute la famille, où tradition française
            et moments de joie se rencontrent.
          </p>
        </div>

        {/* Feature cards */}
        <div className="grid md:grid-cols-3 gap-8 lg:gap-10">
          {features.map((feature, index) => (
            <article
              key={index}
              className="group relative bg-white border border-cream-dark p-8 lg:p-10 transition-all duration-500 hover:shadow-elegant-lg hover:border-gold/30"
            >
              {/* Top accent line on hover */}
              <div className="absolute top-0 left-0 w-full h-0.5 bg-gradient-to-r from-gold via-gold-light to-gold transform scale-x-0 origin-left group-hover:scale-x-100 transition-transform duration-500" />

              {/* Number */}
              <span className="block font-serif text-5xl font-light text-cream-dark group-hover:text-gold/30 transition-colors duration-500 mb-6">
                {feature.number}
              </span>

              {/* Icon */}
              <div className="w-14 h-14 flex items-center justify-center border border-gold/30 text-gold mb-6 group-hover:bg-gold group-hover:text-navy-900 transition-all duration-300">
                {feature.icon}
              </div>

              {/* Content */}
              <h3 className="font-serif text-xl font-semibold text-navy-900 mb-4">
                {feature.title}
              </h3>
              <p className="font-body text-navy-600 leading-relaxed">
                {feature.description}
              </p>

              {/* Bottom corner accent */}
              <div className="absolute bottom-4 right-4 w-8 h-8 border-r border-b border-cream-dark group-hover:border-gold/30 transition-colors duration-300" />
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
